<template>
  <van-button
    round 
    :type="$attrs.type ? $attrs.type : 'primary'"
    v-bind="$attrs"
    v-on="$listeners"
  >
    <slot />
  </van-button>
</template>

<script>
export default {
  name: "aButton",
};
</script>

<style lang="scss" scoped>
</style>


// WEBPACK FOOTER //
// index.vue